import Manifesto from "@/components/Manifesto";
import EditorialMarquee from "@/components/EditorialMarquee";
import { motion } from "framer-motion";

export default function ManifestoPage() {
  return (
    <main className="pt-32 md:pt-40">
      <section className="max-w-[1440px] mx-auto px-6 md:px-10 pb-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.65, 0, 0.35, 1] }}
        >
          <div className="section-tag mb-4">§ Chapter Zero</div>
          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.88] tracking-tighter">
            The <span className="italic text-[#B45309]">Manifesto</span>.
          </h1>
        </motion.div>
      </section>
      <EditorialMarquee />
      <Manifesto />
    </main>
  );
}
